module.exports = __webpack_public_path__ + "static/img/Levietnga.bdde65b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Levietnga.png
// module id = Yn6n
// module chunks = 1